import { render } from "./SubMenuButton.vue?vue&type=template&id=8508d61e&scoped=true"
import script from "./SubMenuButton.vue?vue&type=script&lang=js"
export * from "./SubMenuButton.vue?vue&type=script&lang=js"

import "./SubMenuButton.vue?vue&type=style&index=0&id=8508d61e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8508d61e"]])

export default __exports__